import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import mixpanel from "mixpanel-browser";
import getTenantFromSubdomain from "src/utils/tenantUtils";

// Global Tracker used in App.js
export const MixPanelGlobalTracker = () => {
  const location = useLocation();

  // Register tenant so its included in all events including auto page views
  useEffect(() => {
    if (!mixpanel.config) return; // Ensure Mixpanel is initialized

    const tenant = getTenantFromSubdomain();
    if (tenant) {
      mixpanel.register({ tenant_name: tenant });
    } else {
      mixpanel.unregister("tenant_name");
    }
  }, []);

  // Start session recording
  useEffect(() => {
    if (!mixpanel.config) return; // Ensure Mixpanel is initialized

    mixpanel.start_session_recording();
  }, [location.pathname]);

  return null;
};
